  import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

// 廚房測驗題庫（可彈性擴充）
const kitchenQuiz = [
  {
    title: "【你家的廚房，是黴菌的大本營嗎？】",
    subtitle: "流理臺",
    image: process.env.PUBLIC_URL + "/img/kitchen-quiz1.webp",
    points: [
      { x: 22, y: 32, correct: false }, // 紅點
      { x: 76, y: 58, correct: false }, // 紅點
      { x: 40, y: 58, correct: true },  // 藍點（正確）
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "流理台不是乾淨保證區！黴菌早就在邊邊角角開趴啦～",
        "你是不是以為只要沖水就乾淨了？錯！黴菌超愛縫隙漏洞，尤其流理台又濕又有食物殘渣，根本是它們的天堂。",
        "像是黑黴菌、青黴菌，甚至念珠菌，最愛躲在排水孔、矽膠條裡～不只髒，還可能讓你吸進黴菌抱子，引發過敏、氣喘、皮膚癢，對抵抗力弱的人更危險！",
        "✅三招遠離黴菌流理台：",
        "1. 用完就清，濕物、縫隙、黴除別放過！",
        "2. 保持乾燥，不給黴菌生根的機會",
        "3. 定期清潔，徹底驅離隱形敵人"
      ]
    }
  },
  {
    title: "【你家的廚房，是黴菌的大本營嗎？】",
    subtitle: "冰箱",
    image: process.env.PUBLIC_URL + "/img/kitchen-quiz2.webp",
    points: [
      { x: 20, y: 38, correct: false }, // 紅點
      { x: 68, y: 18, correct: true },  // 藍點（正確）
      { x: 62, y: 62, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "冰箱不是萬能保鮮箱！黴菌悄悄在裡面開趴啦～",
        "你以為把食物放進冰箱就安全了嗎？錯！有些頑強的黴菌超會偷生存，就算在冰箱這種低溫環境，也能慢慢『長大』。",
        "像是我們常見的橘黴、黑黴、甚至酵母，都很愛躲在糊掉的水果、忘記的剩菜、還有冰箱角落的食物屑屑裡。而且，它們不只是髒，還可能讓抵抗力比較弱的人，這些黴菌可是『隱形殺手』喔！",
        "✅簡單三招，讓冰箱不再變黴菌天堂：",
        "1. 定期檢查食物，該丟的就丟！（告別冰箱黑洞）",
        "2. 拖延症退散～定期清潔冰箱超重要！",
        "3. 食物裝盒保存，別讓黴漂亂跑。"
      ]
    }
  },
  {
    title: "【你家的廚房，是黴菌的大本營嗎？】",
    subtitle: "牆壁",
    image: process.env.PUBLIC_URL + "/img/kitchen-quiz3.webp",
    points: [
      { x: 80, y: 28, correct: false }, // 紅點
      { x: 22, y: 80, correct: false }, // 紅點
      { x: 39, y: 38, correct: true },  // 藍點（正確）
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "牆角不是安全地帶！黴菌早就偷偷在牆上偷偷開分店啦～",
        "你是不是只注意流理臺跟水槽，卻忽略了廚房牆壁和角落？？？錯過這些地方，小心黴菌長滿牆還你一片灰黑！",
        "像黑黴菌、青黴菌、還有超愛潮濕、通風差的牆角～尤其是水氣重、油煙多的地方，黴菌不只難看，還可能釋放孢子影響呼吸，讓你過敏、咳不停，嚴重甚至引致肺部感染！",
        "🍖讓牆壁恢復呼吸的三步驟：",
        "1. 烹飪記得開窗或抽油煙機，減少濕氣和油煙～",
        "2. 定期擦牆，尤其水槽、瓦斯爐周邊牆面別忽略",
        "3. 發現發霉馬上清除"
      ]
    }
  },
  {
    title: "【你家的廚房，是黴菌的大本營嗎？】",
    subtitle: "調味料",
    image: process.env.PUBLIC_URL + "/img/kitchen-quiz4.webp",
    points: [
      { x: 17, y: 19, correct: false }, // 紅點
      { x: 51, y: 41, correct: true },  // 藍點（正確）
      { x: 24, y: 77, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "🥜調味料瓶絕不是安全地帶！黴菌最愛悄悄黏在黏黏的地方主動～你是不是用完油瓶就原地擺回去，瓶口還黏黏的？👀小心！廚房潮濕又有溫差，黴菌最喜歡『甜味交錯』的溫床！",
        "像鹽罐、青醬瓶、還有醬醋類調料特別喜歡藏高處分，高濕氣的環境～調味料瓶如果瓶口沒擦乾淨、蓋子鬆鬆的、放在靠近爐火或水槽附近，很容易出問題。",
        "📦瓶蓋內側發霉、結塊、變色",
        "孢子掉進調味料中造成食品污染",
        "吃下含黴菌的調料可能導致腹瀉、嘔心，甚至食物中毒！",
        "🍳讓廚房調味料瓶遠離黴菌的三步驟：",
        "1. 每次使用後瓶口馬上擦乾，黏液、油漬立刻清掉～",
        "2. 不要把瓶罐放在靠近熱火、流理臺、熱水瓶旁邊，避免高溫高濕！🔥💧",
        "3. 每1~2個月定期檢查瓶蓋與內部，有發霉或異味就要淘汰！"
      ]
    }
  },
  
];

export default function Kitchen() {
  const [quizIdx, setQuizIdx] = useState(0);
  const [showInfo, setShowInfo] = useState(false);
  const [wrongClick, setWrongClick] = useState(false);
  const [done, setDone] = useState(false);
  const quiz = kitchenQuiz[quizIdx];

  function handlePointClick(point) {
    if (point.correct) {
      setShowInfo(true);
    } else {
      setWrongClick(true);
      setTimeout(() => setWrongClick(false), 600);
    }
  }

  function handleNext() {
    if (quizIdx < kitchenQuiz.length - 1) {
      setQuizIdx(quizIdx + 1);
      setShowInfo(false);
      setWrongClick(false);
    } else {
      setDone(true);
    }
  }

  const navigate = useNavigate();
  if (done) {
    return (
      <div className="kitchen-quiz-container" style={{ background: '#99C221', minHeight: '100vh', padding: 0 }}>
        <div style={{ maxWidth: 900, margin: '0 auto', background: 'none', borderRadius: 12, padding: 0, textAlign: 'center', minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ fontSize: '3rem', fontWeight: 700, margin: '48px 0 0 0', letterSpacing: 2 }}>太棒了！廚房篇結束</div>
          <div style={{ display: 'flex', justifyContent: 'center', margin: '48px 0 32px 0' }}>
            <img src={process.env.PUBLIC_URL + '/img/finish.webp'} alt="Lulu thumbs up" style={{ width: 220, height: 220, objectFit: 'contain', background: '#444', borderRadius: 16 }} />
          </div>
          <div style={{ fontSize: '2.5rem', fontWeight: 500, margin: '0 0 18px 0', letterSpacing: 1 }}>恭喜你找到廚房中黴菌喜歡生長的地方！</div>
          <div style={{ fontSize: '2.5rem', fontWeight: 500, margin: '0 0 36px 0', letterSpacing: 1 }}>快去檢查看看你的廚房中有沒有這些黴菌吧！</div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: 48 }}>
            <button
              className="main-btn"
              style={{ background: 'rgba(154, 71, 61, 0.97)', color: 'white', border: 'none', padding: '16px 32px', borderRadius: 8, fontSize: '1.5rem', fontWeight: 700, cursor: 'pointer' }}
              onClick={() => navigate('/diagnosis')}
            >
              去檢查
            </button>
            <button 
              onClick={() => navigate('/main')} 
              style={{ background: 'rgba(154, 71, 61, 0.97)', color: 'white', border: 'none', padding: '16px 32px', borderRadius: 8, fontSize: '1.5rem', fontWeight: 700, cursor: 'pointer' }}
            >
              回首頁
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="kitchen-quiz-container" style={{ background: '#99C221', minHeight: '100vh', padding: 20 }}>
      <div style={{ display: 'flex', gap: 24, alignItems: 'center', marginBottom: 16 }}>
        <Link to="/main" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 20, textDecoration: 'none' }}>無黴行動</Link>
        <Link to="/survey" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 18, textDecoration: 'underline' }}>填寫問卷</Link>
      </div>
      <div style={{ maxWidth: 900, margin: '0 auto', background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px #0001', padding: 24 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: '2rem', fontWeight: 700, marginBottom: 8 }}>{quiz.title}</div>
            <div style={{ fontSize: '1.4rem', fontWeight: 500, marginBottom: 12 }}>{quiz.subtitle}</div>
            <div style={{ color: '#444', fontSize: '1rem', marginBottom: 8 }}>《點點看，黴菌在哪裡？》</div>
          </div>
          <img src={process.env.PUBLIC_URL + '/img/03.webp'} alt="Lulu" style={{ width: 120, height: 120, borderRadius: 14, background: '#eee' }} />
        </div>
        <div style={{ position: 'relative', margin: '24px auto', width: 340, height: 260 }}>
          <img
            src={quiz.image}
            alt="quiz"
            style={{ width: 340, height: 260, borderRadius: 10, objectFit: 'cover', border: '2px solid #bbb' }}
          />
          {quiz.points.map((p, idx) => (
            <div
              key={idx}
              onClick={() => handlePointClick(p)}
              style={{
                position: 'absolute',
                left: `calc(${p.x}% - 18px)`,
                top: `calc(${p.y}% - 18px)`,
                width: 36,
                height: 36,
                borderRadius: '50%',
                background: p.correct ? '#ff2e2e' : '#ff2e2e',
                border: '3px solid #fff',
                boxShadow: wrongClick && !p.correct ? '0 0 12px 4px #ff2e2e' : '0 2px 8px #0003',
                cursor: 'pointer',
                transition: 'box-shadow 0.2s',
                zIndex: 2,
                display: showInfo && !p.correct ? 'none' : 'block',
              }}
              title={p.correct ? '正確答案' : '不是這裡'}
            />
          ))}
        </div>
        {showInfo && (
          <div style={{
            background: '#f8f8e8',
            borderRadius: 10,
            margin: '32px 0 0 0',
            padding: '24px 32px',
            boxShadow: '0 1px 6px #0001',
            display: 'flex',
            alignItems: 'flex-start',
            gap: 24,
            border: '2px solid #b0e0e6'
          }}>
            <img src={quiz.info.luluImg} alt="Lulu" style={{ width: 60, height: 60, borderRadius: 10, marginRight: 16 }} />
            <div>
              <div style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: 8 }}>{quiz.info.title}</div>
              {quiz.info.content.map((line, i) => (
                <div key={i} style={{ fontSize: '1.08rem', marginBottom: 4 }}>{line}</div>
              ))}
            </div>
          </div>
        )}
        {showInfo && (
          <div style={{ textAlign: 'right', marginTop: 24 }}>
            <button onClick={handleNext} style={{
              background: '#4caf50',
              color: '#fff',
              fontSize: '1.1rem',
              fontWeight: 600,
              padding: '10px 32px',
              border: 'none',
              borderRadius: 8,
              boxShadow: '0 2px 8px #0001',
              cursor: 'pointer',
              marginRight: 8
            }}>
              {quizIdx < kitchenQuiz.length - 1 ? '下一題 →' : '完成'}
            </button>
          </div>
        )}
      </div>
  </div>);
}


